import { api } from "./client";

export type TemplateKind = "job_ad_notes" | "fitness_report" | "resume" | "cover_letter";

export type PromptTemplate = {
  kind: TemplateKind;
  label: string;
  body_md: string;
  version: number;
  is_default: boolean;
};

export const templatesApi = {
  list: () => api.get<PromptTemplate[]>("/api/templates"),
  readDefault: (kind: TemplateKind) => api.get<PromptTemplate>(`/api/templates/${kind}/default`),
  save: (kind: TemplateKind, body_md: string) =>
    api.put<PromptTemplate>(`/api/templates/${kind}`, { body_md }),
  reset: (kind: TemplateKind) => api.post<PromptTemplate>(`/api/templates/${kind}/reset`, {}),
};
